module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/banner/zh-hant-6d748a97afca628bade13482eb2fd822.jpg";